import api from "@/api/viktor"
import type { NextAssessment } from "@/types/next-assessment"

export async function getNextAssessment(
  pm_uuid?: string,
  company_uuid?: string,
  retake?: boolean
): Promise<NextAssessment> {
  let path = "/me/next-assessment?v=af"
  if (pm_uuid) {
    path = `${path}&pm_uuid=${pm_uuid}`
  }
  if (company_uuid) {
    path = `${path}&company_uuid=${company_uuid}`
  }
  if (retake) {
    path = `${path}&retake=true`
  }

  const response = await api({
    method: "GET",
    url: path,
  })

  return response
}
